import { withErrorBoundary } from 'app/components/error-boundary';
import { Page } from 'app/design/primitives/page';
import { useProfile } from 'app/network/profile';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { ActivityIndicator } from 'react-native';
import { MemberProfileScreen } from './member-profile-screen';
import { SupportProfileScreen } from './support-profile-screen';

const NeighbourProfileScreenComponent: NavigationScreen<'neighbour-profile'> = (props) => {
  const { data: profile } = useProfile(props.route.params.userId, { throwOnError: true });
  if (!profile)
    return (
      <Page>
        <ActivityIndicator />
      </Page>
    );
  return profile.isSupport === true ? (
    <SupportProfileScreen {...props} profile={profile} />
  ) : (
    <MemberProfileScreen {...props} />
  );
};

export const NeighbourProfileScreen: NavigationScreen<'neighbour-profile'> = withOptionalMetrics(
  'NeighbourProfileScreen',
  withErrorBoundary(NeighbourProfileScreenComponent),
);
